interface NavIconProps {
  /** `d` do path; ver NAV_ITEMS em navigation.ts. */
  path: string;
  size?: number;
  className?: string;
}

/** Ícone de traçado do menu — herda a cor de quem o contém. */
export function NavIcon({ path, size = 19, className }: NavIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={path} />
    </svg>
  );
}
